import React from 'react'

import { BrowserProvider } from '../context/browser/BrowserProvider'
import { UserProvider } from 'context/user/UserProvider'
import { AuthMiddlewareProvider } from 'context/authMiddleware'
import { ThemeProvider } from 'context'
import { DismissedRecommendationsProvider } from '@/components/pages/profile_v2'
import { Auth0Provider } from '@auth0/auth0-react'
import { environment } from '@/shared/consts/environment'
import { SearchProviderV2 } from '@/components/search/context/SearchProvider'
import { MainLayout } from '@/layouts/MainLayout'
import { DehydratedState } from '@tanstack/react-query'
import { ReactQueryProvider } from './ReactQuery'
import { MantineProvider } from '@mantine/core'

interface ProvidersProps {
  children: React.ReactNode
  metaProps: {
    title?: string
    description?: string
    image?: string
    twitterDescription?: string
    twitterImage?: string
  }
  dehydratedState?: DehydratedState
}

export const AppProviders = ({
  children,
  metaProps,
  dehydratedState,
}: ProvidersProps) => {
  return (
    <ReactQueryProvider dehydratedState={dehydratedState}>
      <MantineProvider>
        <MainLayout {...metaProps}>
          <Auth0Provider
            authorizeTimeoutInSeconds={3}
            domain={environment.auth0Domain}
            clientId={environment.auth0ClientId}
            useCookiesForTransactions
            cacheLocation="localstorage"
            authorizationParams={{
              redirect_uri: environment.auth0RedirectUri,
              audience: environment.auth0Audience,
              scope: 'read:current_user update:current_user_metadata',
            }}
          >
            <ThemeProvider>
              <BrowserProvider>
                <UserProvider>
                  <AuthMiddlewareProvider>
                    <SearchProviderV2>
                      <DismissedRecommendationsProvider>
                        {children}
                      </DismissedRecommendationsProvider>
                    </SearchProviderV2>
                  </AuthMiddlewareProvider>
                </UserProvider>
              </BrowserProvider>
            </ThemeProvider>
          </Auth0Provider>
        </MainLayout>
      </MantineProvider>
    </ReactQueryProvider>
  )
}
